import PropTypes from 'prop-types';

import AreaInfoBody from './AreaInfoBody';

// View: renderiza informações da área atual sem dropdown.
const AreaInfoView = ({ content }) => {
  return <AreaInfoBody content={content} />;
};

AreaInfoView.propTypes = {
  content: PropTypes.object,
};

export default AreaInfoView;
